import { Route, Routes, Navigate } from 'react-router-dom';
import Home from '../pages/Home';
import Contact from '../pages/Contact';
import ExamProject from '../pages/ExamProject';
import ExamProcedure from '../pages/ExamProcedure';
import ExamFormat from '../pages/ExamFormat';
import ExamNotice from '../pages/ExamNotice';
import ExamInstruction from '../pages/ExamInstruction';
import ExamPlan from '../pages/ExamPlan';
import FormTemplate from '../pages/FormTemplate';
import ReferDocument from '../pages/ReferDocument';
import LegalText from '../pages/LegalText';
import InforStudent from '../pages/InforStudent';
import UserLayout from '../components/UserLayout';
import ArticleDetail from '../pages/ArticleDetail';
import Login from '../pages/Login';

const UserRoutes = () => {
    return (
        <Routes>
            <Route element={<UserLayout />} >
                <Route index element={<Navigate to="/home" />} />
                <Route path="/home" element={<Home />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/exam-project" element={<ExamProject />} />
                <Route path="/exam-procedure" element={<ExamProcedure />} />
                <Route path="/exam-format" element={<ExamFormat />} />
                <Route path="/exam-notice" element={<ExamNotice />} />
                <Route path="/exam-instruction" element={<ExamInstruction />} />
                <Route path="/exam-plan" element={<ExamPlan />} />
                <Route path="/form-template" element={<FormTemplate />} />
                <Route path="/refer-document" element={<ReferDocument />} />
                <Route path="/legal-text" element={<LegalText />} />
                <Route path="/infor-student" element={<InforStudent />} />
                <Route path="/article-detail/:id" element={<ArticleDetail />} />
                <Route path="/login" element={<Login />} />
            </Route>
        </Routes>
    )
}

export default UserRoutes;